import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FieldsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;

  // @media (max-width: 1300px) {
  //   width: 50rem;
  // }
`;

export const RowContainer = styled.div`
  width: 90%;
  height: 3rem;
  background-color: #f6f6f6;
  ${"" /* box-shadow: 2px 4px 6px 4px #d3d3d3; */}
  border-radius: 0.5rem;
  margin: 12px 0;
  display: flex;
  padding-right: 3rem;
  justify-content: space-between;
  align-items: center;
`;

export const LeftContainer = styled.div`
  width: 3rem;
  height: 3rem;
  font-size: 1rem;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  color: white;
  background-image: linear-gradient(to right, #2a3da3, #206be5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightContainer = styled.div`
  display: flex;
  width: 100%;
  padding-left: 1rem;
  column-gap: 3rem;
  justify-content: center;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
`;
